const isHexColor = (str) => /^#[0-9a-f]{3}(?:[0-9a-f]{3})?$/i.test(str);
const combineHexWithOpacity = (hexColor, opacityPercentage) => {
  if (!hexColor) {
    return;
  }
  const alpha = Math.round(opacityPercentage / 100 * 255);
  const alphaHex = alpha.toString(16).padStart(2, "0").toUpperCase();
  return `${hexColor?.slice(0, 7)}${alphaHex}`;
};
const getOpacityFromHex = (hexColorWithAlpha) => {
  if (!hexColorWithAlpha || hexColorWithAlpha.length === 7) {
    return 100;
  }
  const hex = hexColorWithAlpha.replace("#", "");
  const alphaHex = hex.slice(6, 8);
  const alphaDecimal = parseInt(alphaHex, 16);
  return Math.round(alphaDecimal / 255 * 100);
};
const getHexColorFromAlpha = (hexColorWithAlpha) => {
  if (!hexColorWithAlpha || hexColorWithAlpha.length === 7) {
    return hexColorWithAlpha;
  }
  return hexColorWithAlpha.slice(0, 7);
};
export {
  combineHexWithOpacity,
  getHexColorFromAlpha,
  getOpacityFromHex,
  isHexColor
};
//# sourceMappingURL=colorUtils.js.map
